import { isEmpty } from '../../../utils'

export const booleSchemaHandle = {
  handle (node) {
    const {choiceValues, props} = node
    return {
      props: {
        ...props,
        options: choiceValues.map(item => {
          return {
            choiceKey: item.choiceValue.choiceKey,
            value: item.choiceValue.value,
            disabled: item.state === 1
          }
        })
      }
    }
  }
}

export const booleProps = {
  showTooltip: {
    type: Boolean,
    default: true
  },
  value: {
    type: [String, Boolean],
    default: '',
    require: true
  },
  // title
  name: {
    type: String,
    default: ''
  },
  // 是否只读
  disabled: {
    type: Boolean,
    default: false
  },
  // 样式id
  uiComponent: {
    type: Number,
    require: true
  },
  // 选项值
  optionValue: {
    type: String,
    default: '选项值',
    require: false
  },
  // sy-boole-sub 样式
  subClass: {
    type: Boolean,
    default: false
  },
  // 选中时的值
  trueLabel: {
    type: String,
    default: 'true'
  },
  // 没有选中时的值
  falseLabel: {
    type: String,
    default: 'false'
  },
  // 组件尺寸
  size: {
    type: String,
    default: 'small'
  },
  // 数据源
  options: {
    type: Array,
    default: () => [
      {
        choiceValue: {
          choiceKey: 'true',
          // 选项值
          value: '是'
        },
        common: 2,
        defaultChoice: false,
        delete: null,
        isDefaultChoice: false,
        isDelete: null,
        region: 2,
        sortNum: 1,
        state: 0
      },
      {
        choiceValue: {
          choiceKey: 'false',
          // 选项值
          value: '否'
        },
        common: 2,
        defaultChoice: true,
        delete: null,
        isDefaultChoice: true,
        isDelete: null,
        region: 2,
        sortNum: 2,
        state: 0
      }
    ]
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  }
}

function cb (value, field) {
  const choice = field.options.find(v => v.choiceKey === value.toString())
  return choice?.value
}

export function initValue (value, field) {
  return isEmpty(value) ? '-' : cb(value, field)
}
